import { createContext } from 'react';
import { CalendarBodyContextProps } from './CalendarBody.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const CalendarBodyContext = createContext<CalendarBodyContextProps>(undefined);

export default CalendarBodyContext;
